import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { http } from "@/lib/api";
import { RecordShell } from "@/components/records/RecordShell";

export default function CurriculumDoc() {
  const { docKey } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { http.get(`/public/library/${docKey}`).then((r) => setD(r.data)).catch((e) => setErr(e.response?.status === 404 ? "This document isn't published yet." : e.response?.data?.detail || "Not available.")); }, [docKey]);
  if (err) return <p className="text-center py-20 text-stone-500" data-testid="curriculum-doc-error">{err}</p>;
  if (!d) return <p className="text-center py-20 text-stone-500">Loading…</p>;

  return (
    <RecordShell title={d.title} back testId="curriculum-doc-page">
      <p className="text-xs text-stone-400 mt-4" data-testid="curriculum-doc-version">Version {d.version} · Approved {new Date(d.approved_at).toLocaleDateString()}{d.approved_by && ` by ${d.approved_by}`}</p>
      <article className="lesson-md text-stone-700 mt-2" data-testid="curriculum-doc-content">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{d.content}</ReactMarkdown>
      </article>
    </RecordShell>
  );
}
